import React from 'react';

import { DAILY_MESSAGE_LIMIT } from '~components/business-owner/barry/utils';

import {
	DarkBarryIcon,
	SendButtonSmallBlueIcon,
	SendButtonSmallIcon,
} from '~assets/images';
import { callErrorToast } from '~utils/toasts';

import styles from './BarryIndividualConversation.module.scss';

import { BARRY_PROMPT_SUGGESTIONS } from './constants';

interface BarryNewConversationViewProps {
	messageInput: string;
	hasHitDailyLimit: boolean;
	onInputChange: (event: React.ChangeEvent<HTMLInputElement>) => void;
	onKeyDown: (event: React.KeyboardEvent<HTMLInputElement>) => void;
	onSubmit: () => void;
	onSuggestionSelect: (suggestion: string) => void;
}

export const BarryNewConversationView: React.FC<BarryNewConversationViewProps> = (
	props,
) => {
	const {
		messageInput,
		hasHitDailyLimit,
		onInputChange,
		onKeyDown,
		onSubmit,
		onSuggestionSelect,
	} = props;

	const handleSuggestionClick = (suggestion: string): void => {
		if (hasHitDailyLimit) {
			callErrorToast({
				content: `You have reached your daily message limit of ${DAILY_MESSAGE_LIMIT} with Barry! Your limit will reset tomorrow.`,
			});
			return;
		}
		onSuggestionSelect(suggestion);
	};

	return (
		<div className={styles.barryNewConversationContainer}>
			<div className={styles.barryWelcomeContainer}>
				<h1 className={styles.barryTitle}>
					Hi, I&apos;m Barry, your virtual assistant!
				</h1>
				<p className={styles.barryDescription}>
					You can ask me questions about your Cents data.
					<br />
					Start by typing a prompt below or selecting one of the quick options.
				</p>
			</div>
			<div className={styles.barrySearchContainer}>
				<div className={styles.barrySearchWrapper}>
					<DarkBarryIcon style={{ marginRight: '0.75rem' }} />
					<input
						type="text"
						placeholder="What can I do for you?"
						className={styles.barrySearchInput}
						value={messageInput}
						onChange={onInputChange}
						onKeyDown={onKeyDown}
					/>
					<button className={styles.barrySendButton} onClick={onSubmit}>
						{messageInput.length > 0 ? (
							<SendButtonSmallBlueIcon />
						) : (
							<SendButtonSmallIcon />
						)}
					</button>
				</div>
			</div>
			<div className={styles.barryActions}>
				{BARRY_PROMPT_SUGGESTIONS.map((suggestion, index) => (
					<button
						key={index}
						className={styles.barryActionButton}
						onClick={() => handleSuggestionClick(suggestion.title)}
					>
						<span className={styles.barryActionText}>{suggestion.title}</span>
					</button>
				))}
			</div>
		</div>
	);
};
